import * as z from "zod";

export const getGoogleMerchantCenterOAuthURL = {
  name: "getGoogleMerchantCenterOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
